import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const ProjectListLayout = styled.div`
  display: flex;
  gap: 60px;
  @media (max-width: ${breakpoints[1]}) {
    flex-direction: column;
  }
`;

export const ProjectsAndBadgesColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;
